import {
  GET_EXPENSE_CATEGORIES_REQUEST,
  GET_EXPENSE_CATEGORIES_SUCCESS,
  GET_EXPENSE_CATEGORIES_FAILURE,
  GET_EXPENSE_CATEGORY_REQUEST,
  GET_EXPENSE_CATEGORY_SUCCESS,
  GET_EXPENSE_CATEGORY_FAILURE,
  CREATE_EXPENSE_CATEGORY_REQUEST,
  CREATE_EXPENSE_CATEGORY_SUCCESS,
  CREATE_EXPENSE_CATEGORY_FAILURE,
  UPDATE_EXPENSE_CATEGORY_REQUEST,
  UPDATE_EXPENSE_CATEGORY_SUCCESS,
  UPDATE_EXPENSE_CATEGORY_FAILURE,
  DELETE_EXPENSE_CATEGORY_REQUEST,
  DELETE_EXPENSE_CATEGORY_SUCCESS,
  DELETE_EXPENSE_CATEGORY_FAILURE,
  GET_CATEGORY_HIERARCHY_REQUEST,
  GET_CATEGORY_HIERARCHY_SUCCESS,
  GET_CATEGORY_HIERARCHY_FAILURE
} from '../types';

const initialState = {
  categories: [],
  currentCategory: null,
  hierarchy: [],
  loading: false,
  error: null
};

const expenseCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Expense Categories
    case GET_EXPENSE_CATEGORIES_REQUEST:
    case GET_CATEGORY_HIERARCHY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload.data,
        error: null
      };

    case GET_CATEGORY_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        hierarchy: action.payload.data,
        error: null
      };

    case GET_EXPENSE_CATEGORIES_FAILURE:
    case GET_CATEGORY_HIERARCHY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get Single Expense Category
    case GET_EXPENSE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        currentCategory: action.payload.data,
        error: null
      };

    case GET_EXPENSE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Create Expense Category
    case CREATE_EXPENSE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_EXPENSE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [...state.categories, action.payload.data],
        error: null
      };

    case CREATE_EXPENSE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update Expense Category
    case UPDATE_EXPENSE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case UPDATE_EXPENSE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.map(category =>
          category.id === action.payload.data.id ? action.payload.data : category
        ),
        currentCategory: state.currentCategory?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentCategory,
        hierarchy: updateCategoryInHierarchy(state.hierarchy, action.payload.data),
        error: null
      };

    case UPDATE_EXPENSE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete Expense Category
    case DELETE_EXPENSE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_EXPENSE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter(category => category.id !== action.payload.id),
        currentCategory: state.currentCategory?.id === action.payload.id 
          ? null 
          : state.currentCategory,
        hierarchy: removeCategoryFromHierarchy(state.hierarchy, action.payload.id),
        error: null
      };

    case DELETE_EXPENSE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

// Helper function to update category in hierarchy
const updateCategoryInHierarchy = (hierarchy, updatedCategory) => {
  return hierarchy.map(category => {
    if (category.id === updatedCategory.id) {
      return { ...category, ...updatedCategory };
    }
    if (category.children && category.children.length > 0) {
      return {
        ...category,
        children: category.children.map(child =>
          child.id === updatedCategory.id ? { ...child, ...updatedCategory } : child
        )
      };
    }
    return category;
  });
};

// Helper function to remove category from hierarchy
const removeCategoryFromHierarchy = (hierarchy, categoryId) => {
  return hierarchy
    .filter(category => category.id !== categoryId)
    .map(category => ({
      ...category,
      children: category.children ? 
        category.children.filter(child => child.id !== categoryId) : []
    }));
};

export default expenseCategoryReducer;
